import { useState } from 'react';
import { faqData } from '@/mocks/about';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqLD = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqLD)}</script>
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于国产视频大全的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h4 className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-500 text-white rotate-45' : 'bg-secondary-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}